import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BookDemoMutationVariables = Types.Exact<{
  data: Types.BookDemoInput;
}>;


export type BookDemoMutationPage = { readonly __typename?: 'RootMutationType', readonly bookDemo: boolean };


export const BookDemoDocument = gql`
    mutation BookDemo($data: BookDemoInput!) {
  bookDemo(input: $data)
}
    `;
export type BookDemoMutationFn = Apollo.MutationFunction<BookDemoMutationPage, BookDemoMutationVariables>;

/**
 * __useBookDemoMutation__
 *
 * To run a mutation, you first call `useBookDemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookDemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookDemoMutation, { data, loading, error }] = useBookDemoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBookDemoMutation(baseOptions?: Apollo.MutationHookOptions<BookDemoMutationPage, BookDemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookDemoMutationPage, BookDemoMutationVariables>(BookDemoDocument, options);
      }
export type BookDemoMutationHookResult = ReturnType<typeof useBookDemoMutation>;
export type BookDemoMutationResult = Apollo.MutationResult<BookDemoMutationPage>;
export type BookDemoMutationOptions = Apollo.BaseMutationOptions<BookDemoMutationPage, BookDemoMutationVariables>;